import React from 'react';
import styled from 'styled-components';

import { Heading } from '@rover/kibble/core';
import Accordion, {
  AccordionHeaderClickTarget,
} from '@rover/react-lib/src/components/layouts/Accordion';

const NoPaddingLeftAccordion = styled(Accordion)`
  ${AccordionHeaderClickTarget} {
    padding-left: 0;
    color: ${({ theme }) => theme.textColor.primary};
  }
`;

type Props = {
  sectionName: string;
  title: string;
  body: React.ReactNode;
  onExpand?: () => void;
};

const AccordionSection: React.FC<Props> = ({ sectionName, title, body, onExpand }) => (
  <NoPaddingLeftAccordion
    data-testid={sectionName}
    isRightIcon
    isStackedAccordion
    openIcon="rover-icon-in-up"
    closedIcon="rover-icon-in-down"
    header={
      <Heading webProps={{ responsive: false }} size="400" mb="0x">
        {title}
      </Heading>
    }
    body={body}
    onToggle={(expanded) => {
      if (expanded) {
        onExpand?.();
      }
    }}
  />
);

export default AccordionSection;
